import { useAxios } from "@hooks"
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export interface MonthlyExamTermData {
    month: string;
    count: number;
}

export interface MonthlyCandidateData {
    month: string;
    total: number;
    passed: number;
    noShow: number;
    waitingCorrection: number;
}

export interface QuestionTypeData {
    type: string;
    count: number;
}

export interface CategoryQuestionData {
    category: string;
    count: number;
}

export interface DashboardStatistics {
    totalExams: number;
    totalExamTerms: number;
    activeExamTerms: number;
    totalParticipants: number;
    totalQuestions: number;
    termsInProgressToday: number;
    upcomingTerms: number;
    termsNeedingCompletion: number;
    pendingCorrections: number;
    candidatesByMonth: MonthlyCandidateData[];
    examTermsByMonth: MonthlyExamTermData[];
    questionsByType: QuestionTypeData[];
    questionsByCategory: CategoryQuestionData[];
}

export const useGetDashboardStatistics = (enabled: boolean = true) => {
    const axios = useAxios();
    const {t} = useTranslation();

    const getStatistics = async (): Promise<DashboardStatistics> => {
        try {
            const response = await axios.get("/api/dashboard/statistics");
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.getDashboardStatistics"));
        }
    }

    return useQuery({
        queryKey: ["dashboardStatistics"],
        queryFn: getStatistics,
        staleTime: 60000, // 1 minute
        enabled
    })
}
